<ng-container>
  <div class="w-full custom-weight-input">
    <!-- LB Mode -->
    <div
      class="flex flex-col"
      [ngClass]="{
        'custom-field-focused': isFocused,
        'custom-field-hovered': isHovered
      }"
      *ngIf="conversionWeightService.preferredWeightUnit === WeightUnit.LB"
    >
      <div class="flex">
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Weight</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="lb"
            (ngModelChange)="onInputChange()"
            (blur)="onBlur()"
            (focus)="onFocus()"
            (mouseenter)="onMouseEnter()"
            (mouseleave)="onMouseLeave()"
          />
          <span matSuffix class="text-gray-500 text-sm px-1">lb</span>
        </mat-form-field>
      </div>
      <mat-error
        *ngIf="
          (ngControl?.control?.hasError('min') ||
            ngControl?.control?.hasError('max')) &&
          ngControl?.control?.touched
        "
      >
        select a value between {{limits.LB.MIN}}lb and {{limits.LB.MAX}}lb
      </mat-error>
    </div>

    <!-- KG Mode -->
    <div
      class="flex flex-col"
      [ngClass]="{
        'custom-field-focused': isFocused,
        'custom-field-hovered': isHovered
      }"
      *ngIf="conversionWeightService.preferredWeightUnit === WeightUnit.KG"
    >
      <div class="flex">
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Weight</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="kg"
            (ngModelChange)="onInputChange()"
            (blur)="onBlur()"
            (focus)="onFocus()"
            (mouseenter)="onMouseEnter()"
            (mouseleave)="onMouseLeave()"
          />

          <span matSuffix class="text-gray-500 text-sm px-1">kg</span>
        </mat-form-field>
      </div>
      <mat-error
        *ngIf="
          (ngControl?.control?.hasError('min') ||
            ngControl?.control?.hasError('max')) &&
          ngControl?.control?.touched
        "
      >
        select a value between {{limits.KG.MIN}}kg and {{limits.KG.MAX}}kg
      </mat-error>
    </div>
  </div>
</ng-container>
